export const FileFormats = {
    PDF: '.pdf',
    DOC: '.doc',
    DOCX: '.docx',
    XLS: '.xls',
    XLSX: '.xlsx',
    TXT: '.txt',
    CSV: '.csv',
    PPT: '.ppt',
    PPTX: '.pptx',
    ZIP: '.zip',
    RAR: '.rar',
    ODT: '.odt',
    ODS: '.ods',
    ODP: '.odp',
    HTML: '.html',
    XML: '.xml',
    JSON: '.json',
    MD: '.md',
    RTF: '.rtf',
    LOG: '.log',
    ALL: '*',
};